
import { ChangeDetectorRef, Component, ElementRef, HostListener, HostBinding, Inject, Input, OnDestroy, OnInit, Optional, Output, EventEmitter } from '@angular/core';
import { MatPseudoCheckboxState } from '@angular/material/core';
import { MAT_OPTION_PARENT_COMPONENT, MatOptgroup, MatOption, MatOptionParentComponent } from '@angular/material/core';
import { AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-mat-select-multiple-all',
  templateUrl: './mat-select-multiple-all.component.html',
  styleUrls: ['./mat-select-multiple-all.component.scss']
})
export class MatSelectMultipleAllComponent extends MatOption implements OnInit, OnDestroy {
  protected unsubscribe: Subject<any>;

  @Input() control: AbstractControl;
  @Input() title: string;
  @Input() emitEvent: boolean;
  @Input() values: any[] = [];
  @Input() valueKey: string;
  @Output() notify = new EventEmitter();
  
  @HostBinding('class') cssClass = 'mat-option';

  @HostListener('click') toggleSelection(): void {
    let allRecordIds = this.values.map(value => {
      return this.readObjectPropertyValue(value,this.valueKey);
    });

    this._selectViaInteraction();
     
    if(this.selectedItemsCount>0 && this.selectedItemsCount<allRecordIds.length && !this.selected){
      this.control.setValue(this.selected ? [] : allRecordIds);
    }else{
      if(this.selectedItemsCount===allRecordIds.length)
      {
        this.control.setValue([]);
      }else{
        this.control.setValue(this.selected ? allRecordIds : []);
      }
      
    }
   // this.control.setValue(this.selected ? allRecordIds : []);

    this.control.markAsDirty();
    if(this.emitEvent){
      this.notify.emit();
    }
  }

  constructor(elementRef: ElementRef<HTMLElement>,
    changeDetectorRef: ChangeDetectorRef,
    @Optional() @Inject(MAT_OPTION_PARENT_COMPONENT) parent: MatOptionParentComponent,
    @Optional() group: MatOptgroup, private translate: TranslateService) {
    super(elementRef, changeDetectorRef, parent, group);

  }

  ngOnInit(): void {
    this.unsubscribe = new Subject<any>();

    this.refresh();

    this.control.valueChanges
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => {
        this.refresh();
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.notify.unsubscribe();
    
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
  }

  get selectedItemsCount(): number {
    return this.control && Array.isArray(this.control.value) ? this.control.value.filter(el => el !== null).length : 0;
  }

  get selectedAll(): boolean {
    return this.values!=null ? this.selectedItemsCount === this.values.length : false;
  }

  get selectedPartially(): boolean {
    const selectedItemsCount = this.selectedItemsCount;

    return this.values!=null ?  selectedItemsCount > 0 && selectedItemsCount < this.values.length : false;
  }

  get checkboxState(): MatPseudoCheckboxState {
    let state: MatPseudoCheckboxState = 'unchecked';

    if (this.selectedAll) {
      state = 'checked';
    } else if (this.selectedPartially) {
      state = 'indeterminate';
    }

    return state;
  }

  refresh(): void {
    if (this.selectedItemsCount >= 0) {
      this.select();
    } else {
      this.deselect();
    }
  }

  readObjectPropertyValue(obj, prop) {
     
    if (prop === "Item") {
      return obj;
    }
    return obj[prop];
    
  }
}
